<template>
  <div class="sharePage">
    <knowledgeDetail :id="id" :showViewCount="true" :url="$apis.common.getKnowledge" v-if="id" />
  </div>
</template>
<script>
export default {
  name: 'shareKnowledge',
  data () {
    return {
      id: null,
      key: null
    }
  },
  methods: {
    getShareKnowledgeInfo: function () {
      if (this.key && this.key.trim() != '') {
        let that = this
        let params = this.$paramsCrypto.decrypt(this.key).split("|")
        this.id = params[0]
      } else {
        this.$Message.error({
          content: '无效链接！',
          duration: 3
        })
      }
    }
  },
  beforeMount () {
    this.key = decodeURIComponent(this.$route.query?.params || '')
    console.log('key', this.key)
    this.getShareKnowledgeInfo()
  }
}
</script>
<style lang="less" scoped>
.sharePage {
  text-align: left;
  padding: 1rem;
  height: 100%;
  overflow-y: auto;
}
</style>